import { FormContainerStepProps } from 'components';
import { useTranslation } from 'libs/i18n';
import {
  ClientType,
  FormBodyWrapper,
} from 'modules/onboarding/common/components';

import {
  getSchema,
  FormErrors,
  CompanyAddressFormType,
} from '../../forms/companyAddressForm';

import { FormContent, FormContentProps } from './FormContent';

interface CompanyRegistrationAddressProps
  extends FormContentProps,
    FormContainerStepProps {
  initialValues?: CompanyAddressFormType;
  onSubmit: (values: CompanyAddressFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  clientType?: ClientType;
  submitDisabled?: boolean;
  subTitle?: string;
  title?: string;
}

export const CompanyRegistrationAddress = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  formError,
  onSubmit,
  clientType,
  step,
  subTitle,
  title,
  submitDisabled,
  ...formProps
}: CompanyRegistrationAddressProps) => {
  const schema = getSchema(formProps.enabledFiles);
  const { t } = useTranslation();
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      step={step}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={subTitle ?? t('onboarding.companyRegistrationAddress.subtitle')}
      title={title ?? t('onboarding.companyRegistrationAddress.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormBodyWrapper>
  );
};
